import { Routes, Route } from "react-router-dom";
import Onboarding from "@/pages/mobile/Onboarding";
import MobileDesigner from "@/pages/mobile/Designer";
import MobileResults from "@/pages/mobile/Results";
import MobileRoomRefresh from "@/pages/mobile/RoomRefresh";
import Auth from "@/pages/Auth";
import Projects from "@/pages/Projects";
import Settings from "@/pages/Settings";
import Pricing from "@/pages/Pricing";
import Support from "@/pages/Support";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import Notifications from "@/pages/Notifications";
import Explore from "@/pages/Explore";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FeedbackAndTestimonials from "@/pages/FeedbackAndTestimonials";

/**
 * Mobile-specific routing configuration
 * Optimized for native iOS and Android apps
 */
export const MobileRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Onboarding />} />
      <Route path="/designer" element={<MobileDesigner />} />
      <Route path="/room-refresh" element={<MobileRoomRefresh />} />
      <Route path="/results" element={<MobileResults />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/support" element={<Support />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/feedback-and-testimonials" element={<FeedbackAndTestimonials />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};
